const TABLE_SIZES = {
  fullName: { lg: 8, xs: 16 },
  email: { lg: 8, xs: 16 },
  phoneNumber: { lg: 8, xs: 16 },
  password: { lg: 8, xs: 16 }
}

export default TABLE_SIZES
